export default __webpack_public_path__ + "static/media/hacobell-brand-foreground-white.7c23803c.svg";